/* ============================================================
   eb-bb-tasks.js · BlackoutBox Basic, Section „Aufgaben" als Systemkarte (Option B)
   Vorlage: konzept/final/tasks-B/mockup.html (Korrekturfassung 08.10.2026), Owner-Go 10.10.

   Zeichnet die Leitungen (Sonne, Kurbel, Dein Handy, Zuend-Linie) aus den Modulpositionen,
   prueft das Ergebnis selbst (keine Ueberlappung, kein Textueberlauf, keine Linie durch Text,
   keine Kreuzung) und weicht sonst auf zwei Stufen ohne Leitungen aus:
   is-plain = Liste, Knoepfe bleiben auf dem Rahmen · is-flow = Knoepfe als Zeile unter dem Koffer.
   Wegwahl ueber die drei Knoepfe (aria-pressed, Esc), einmaliger Lichtlauf beim Einscrollen.
   Ohne dieses Skript steht die Karte vollstaendig ohne Linien da (Progressive Enhancement).
   Keine Abhaengigkeiten, laedt mit defer, idempotent bei shopify:section:load.
   ============================================================ */
(function () {
  'use strict';
  if (window.ebBbTasks) { window.ebBbTasks.initAll(document); return; }

  var NS = 'http://www.w3.org/2000/svg';
  /* Welche Wege und Module zu welchem Knopf gehoeren */
  var SETS = {
    sonne: { r: ['sonne'], m: ['kurbellampe', 'powerbank', 'kurbelradio'] },
    kurbel: { r: ['kurbel'], m: ['kurbelradio', 'kurbellampe'] },
    handy: { r: ['handy'], m: ['powerbank', 'kurbelradio'] }
  };
  var canAnim = typeof document.documentElement.animate === 'function';

  function f(n) { return Math.round(n * 10) / 10; }
  function arr(list) { return Array.prototype.slice.call(list); }
  function box(node, m) {
    var r = node.getBoundingClientRect();
    return { l: r.left - m.left, t: r.top - m.top, r: r.right - m.left, b: r.bottom - m.top, cx: (r.left + r.right) / 2 - m.left, cy: (r.top + r.bottom) / 2 - m.top, w: r.width, h: r.height };
  }
  function over(a, b, pad) { return a.r + pad > b.l && a.l - pad < b.r && a.b + pad > b.t && a.t - pad < b.b; }
  function segBox(a, b, pad) { return { l: Math.min(a[0], b[0]) - pad, r: Math.max(a[0], b[0]) + pad, t: Math.min(a[1], b[1]) - pad, b: Math.max(a[1], b[1]) + pad }; }
  function clean(pts) {
    var out = [pts[0]];
    for (var i = 1; i < pts.length; i++) { var a = out[out.length - 1], b = pts[i]; if (Math.abs(a[0] - b[0]) > 0.4 || Math.abs(a[1] - b[1]) > 0.4) out.push(b); }
    for (var j = out.length - 2; j > 0; j--) {
      var p = out[j - 1], q = out[j], s = out[j + 1];
      if ((Math.abs(p[0] - q[0]) < 0.5 && Math.abs(q[0] - s[0]) < 0.5) || (Math.abs(p[1] - q[1]) < 0.5 && Math.abs(q[1] - s[1]) < 0.5)) out.splice(j, 1);
    }
    return out;
  }
  /* Polylinie mit runden Ecken (Radius R, bei kurzen Stuecken kleiner) */
  function rounded(pts, R) {
    var d = 'M' + f(pts[0][0]) + ',' + f(pts[0][1]);
    for (var i = 1; i < pts.length - 1; i++) {
      var a = pts[i - 1], b = pts[i], c = pts[i + 1];
      var l1 = Math.hypot(b[0] - a[0], b[1] - a[1]), l2 = Math.hypot(c[0] - b[0], c[1] - b[1]);
      var r = Math.min(R, i === 1 ? l1 : l1 / 2, i === pts.length - 2 ? l2 : l2 / 2);
      var p = [b[0] + (a[0] - b[0]) * r / l1, b[1] + (a[1] - b[1]) * r / l1], q = [b[0] + (c[0] - b[0]) * r / l2, b[1] + (c[1] - b[1]) * r / l2];
      var sweep = ((b[0] - a[0]) * (c[1] - b[1]) - (b[1] - a[1]) * (c[0] - b[0])) > 0 ? 1 : 0;
      d += ' L' + f(p[0]) + ',' + f(p[1]) + ' A' + f(r) + ',' + f(r) + ' 0 0 ' + sweep + ' ' + f(q[0]) + ',' + f(q[1]);
    }
    var z = pts[pts.length - 1];
    return d + ' L' + f(z[0]) + ',' + f(z[1]);
  }
  function mk(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); if (parent) parent.appendChild(n); return n; }
  function finished(a) { return a.finished || Promise.resolve(); }

  function init(root) {
    if (!root || root.__ebBbSk) return;
    var map = root.querySelector('[data-sk-map]');
    var svg = map && map.querySelector('.bb-sk__svg');
    var caseEl = map && map.querySelector('.bb-sk__case');
    var tagN = map && map.querySelector('.bb-sk__tag--n'), tagO = map && map.querySelector('.bb-sk__tag--o');
    var bS = map && map.querySelector('.bb-sk__term--sonne'), bK = map && map.querySelector('.bb-sk__term--kurbel'), bH = map && map.querySelector('.bb-sk__term--handy');
    if (!svg || !caseEl || !tagN || !tagO || !bS || !bK || !bH || typeof svg.getBBox !== 'function') return;

    var btns = arr(map.querySelectorAll('[data-path]'));
    var caps = {}; arr(root.querySelectorAll('.bb-sk__cap [data-k]')).forEach(function (p) { caps[p.getAttribute('data-k')] = p; });
    if (!caps.s0) return;
    var live = root.querySelector('[data-sk-live]');
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var desk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: false };
    var cs = getComputedStyle(root);
    var tok = function (n) { return cs.getPropertyValue(n).trim(); };
    var el = function (sel) { return map.querySelector(sel); };
    var state = 's0', routes = [], frameD = '', running = [], ran = false, lastSig = '', capTimer = 0, dead = false;
    var io = null, ro = null, pending = false;
    function reduce() { return !!(reduceMq && reduceMq.matches); }

    /* ---- Geometrie ---- */
    function reset() {
      root.classList.remove('is-alt'); map.classList.remove('is-plain', 'is-flow'); tagN.classList.remove('is-off');
      ['--sk-ht', '--sk-hb', '--sk-tagw', '--sk-tagh', '--sk-colmin'].forEach(function (v) { map.style.removeProperty(v); });
      [bS, bK, bH, tagN].forEach(function (n) { n.style.top = ''; n.style.left = ''; n.style.right = ''; n.style.bottom = ''; n.style.removeProperty('--sk-bl'); n.style.removeProperty('--sk-br'); });
    }
    function setHalf() { /* Knopfhoehe kann mit der Schrift wachsen: Rahmenlinie bleibt mittig auf den Knoepfen */
      map.style.setProperty('--sk-ht', f(Math.max(bS.offsetHeight, bK.offsetHeight) / 2) + 'px');
      map.style.setProperty('--sk-hb', f(bH.offsetHeight / 2) + 'px');
    }
    /* Etiketten oben/unten: "13 Module" mittig in der Luecke oder ausblenden, "Ordnung" darf zweizeilig werden */
    function fitTags(m, handyL) {
      var cb = box(caseEl, m), s = box(bS, m), k = box(bK, m);
      var gap = k.l - s.r, tw = tagN.offsetWidth;
      if (gap - tw < 20) tagN.classList.add('is-off');
      else {
        tagN.style.left = f((s.r + k.l) / 2 - cb.l - 1.5) + 'px';
        var stubN = (gap - tw) / 2 - 7; if (stubN < 16) { bS.style.setProperty('--sk-br', f(7 + stubN + 1.5) + 'px'); bK.style.setProperty('--sk-bl', f(7 + stubN + 1.5) + 'px'); }
      }
      var t = box(tagO, m);
      if (t.r + 10 > handyL) { map.style.setProperty('--sk-tagw', f(handyL - 10 - t.l) + 'px'); t = box(tagO, m); }
      if (tagO.scrollWidth > tagO.clientWidth + 1) return false;   /* Text laeuft ueber das Etikett hinaus */
      /* kurze Reststuecke der Rahmenlinie (unter 16 px) wirken wie Striche: die Freistellung am Knopf deckt sie mit ab */
      var stubO = handyL - 7 - t.r; if (stubO > 0 && stubO < 16) bH.style.setProperty('--sk-bl', f(7 + stubO + 1.5) + 'px');
      return t.r + 10 <= handyL + 0.5;
    }
    /* Selbstpruefung: keine Ueberlappung von Text, Knoepfen, Etiketten, Linien, alles innerhalb der Karte */
    function check(m, list, lbl) {
      var err = [], W = map.clientWidth, cb = box(caseEl, m);
      var items = arr(map.querySelectorAll('.bb-sk__w, .bb-sk__m, .bb-sk__term, .bb-sk__tag')).filter(function (n) { return n.offsetParent !== null; })
        .map(function (n) { return { b: box(n, m), btn: n.getAttribute('data-path'), tag: n.classList.contains('bb-sk__tag'), name: n.textContent.trim().slice(0, 12), ov: !n.getAttribute('data-path') && n.scrollWidth > n.clientWidth + 1 }; });
      if (lbl) items.push({ b: lbl, lbl: true, name: 'zündet' });
      items.forEach(function (o) { if (o.b.l < -0.5 || o.b.r > W + 0.5) err.push('ausserhalb ' + o.name); if (o.ov) err.push('Text laeuft ueber ' + o.name); });
      items.forEach(function (o) { if (!o.btn && !o.lbl && !o.tag && (o.b.r > cb.r - 3 || o.b.l < cb.l + 1)) err.push('Koffer ' + o.name); });
      for (var i = 0; i < items.length; i++) for (var j = i + 1; j < items.length; j++) {
        var A = items[i], B = items[j];
        var pad = (A.btn || B.btn || A.tag || B.tag) ? 4 : 0;
        if (over(A.b, B.b, pad)) err.push('Ueberlappung ' + A.name + ' / ' + B.name);
      }
      list.forEach(function (r) {
        for (var s = 1; s < r.pts.length; s++) {
          var sb = segBox(r.pts[s - 1], r.pts[s], 1.5);
          items.forEach(function (o) { if (o.btn && (o.btn === r.set)) return; if (over(sb, o.b, 0)) err.push('Linie ' + r.id + ' trifft ' + o.name); });
        }
        if (r.pts.length > 2) { var p = r.pts[r.pts.length - 2], q = r.pts[r.pts.length - 1]; if (Math.hypot(q[0] - p[0], q[1] - p[1]) < 6) err.push('Ecke zu eng ' + r.id); }
      });
      for (var a = 0; a < list.length; a++) for (var b = a + 1; b < list.length; b++) {
        if (list[a].set === list[b].set) continue;
        for (var x = 1; x < list[a].pts.length; x++) for (var y = 1; y < list[b].pts.length; y++)
          if (over(segBox(list[a].pts[x - 1], list[a].pts[x], 0), segBox(list[b].pts[y - 1], list[b].pts[y], 0), 3)) err.push('Kreuzung ' + list[a].id + ' / ' + list[b].id);
      }
      return err;
    }

    /* Leitungsplan berechnen (D = Desktop-Fluss, sonst Mobil-Plan). Liefert {ok, list, err} */
    function plan2(D) {
      var m, W = map.clientWidth;
      var A = D ? 9 : 7, AW = D ? 5 : 4, PR = 3.35, R = 10, G = 3;
      if (!D) setHalf();
      m = map.getBoundingClientRect();
      var mod = function (k) { return box(el('[data-m="' + k + '"]'), m); };
      var st = function (k) { return box(el('[data-st="' + k + '"]'), m); };
      var word = function (k) { return box(el('[data-st="' + k + '"] .bb-sk__w'), m); };
      var kl = mod('kurbellampe'), kz = mod('kerze'), pb = mod('powerbank'), kr = mod('kurbelradio'), fz = mod('feuerzeug');
      var inL = function (b) { return [b.l - G - A, b.cy, b.l - G, b.cy]; };   /* Pfeil von links, Spitze 3 px vor dem Modul */
      var inR = function (b) { return [b.r + G + A, b.cy, b.r + G, b.cy]; };
      var inB = function (b) { return [b.cx, b.b + G + A, b.cx, b.b + G]; };
      var pB = function (b) { return [b.cx, b.b + 3.5]; }, pR = function (b) { return [b.r + 4, b.cy]; };
      var list = [], err = [];
      function add(id, set, pts, tip, ports, opt) { list.push({ id: id, set: set, pts: clean(pts), tip: tip, ports: ports || [], fire: !!(opt && opt.fire) }); }
      var sonne, kurbel, handy, cb, a;

      if (!D) {
        sonne = box(bS, m); kurbel = box(bK, m);
        if (sonne.r + 8 > kurbel.l) return { ok: false, err: ['Knoepfe oben zu breit'] };
        /* Dein Handy: rechte Rahmenkante endet im Eckradius, Pfeil vom Kurbelradio landet rechts im Knopf */
        var hw = bH.offsetWidth, L = Math.min(W - hw - 26, kr.cx - 38);
        if (kr.cx > L + hw - 14) L = kr.cx - hw + 14;
        if (L < 0 || L + hw > W) return { ok: false, err: ['Handy passt nicht'] };
        bH.style.left = f(L) + 'px'; bH.style.right = 'auto';
        if (!fitTags(m, L)) return { ok: false, err: ['Etikett Ordnung passt nicht'] };
        sonne = box(bS, m); kurbel = box(bK, m); handy = box(bH, m); cb = box(caseEl, m);
        kl = mod('kurbellampe'); kz = mod('kerze'); pb = mod('powerbank'); kr = mod('kurbelradio'); fz = mod('feuerzeug');
        var c2right = Math.max.apply(null, ['waerme', 'gesundheit', 'information'].map(function (k) { return Math.max.apply(null, arr(map.querySelectorAll('[data-st="' + k + '"] .bb-sk__w, [data-st="' + k + '"] .bb-sk__m')).map(function (n) { return box(n, m).r; })); }));
        var tL = sonne.l + 16, tR = Math.max(kurbel.r - 18, c2right + 10);
        if (tR > cb.r - 7) return { ok: false, err: ['rechter Stamm hat keinen Platz'] };
        var c2 = st('waerme').l, aB = c2 - 6 - G - A - R - 2, aA = aB + 12;
        if (aA < kl.r + G + A + R + 2) return { ok: false, err: ['Mittelgasse zu schmal'] };
        if (tL > kl.l - G - A - R) return { ok: false, err: ['linker Stamm zu nah'] };
        var r1 = Math.max(st('werkzeug').b, st('waerme').b), r2t = Math.min(st('licht').t, st('gesundheit').t);
        var r2 = Math.max(st('licht').b, st('gesundheit').b), r3t = Math.min(st('energie').t, st('information').t);
        var r3 = Math.max(st('energie').b, st('information').b);
        var ch1 = (r1 + r2t) / 2, ch2 = (r2 + r3t) / 2, ch3 = Math.max(r3 + 10, pB(pb)[1] + PR + 12);
        var xh1 = Math.min(handy.l + 18, pB(kr)[0] - 20);
        if (xh1 < handy.l + 12) return { ok: false, err: ['Pfeile zum Handy zu eng'] };
        a = inL(kl); add('sonne-kurbellampe', 'sonne', [[tL, sonne.b], [tL, kl.cy], [a[0], a[1]]], a);
        a = inL(kr); add('sonne-kurbelradio', 'sonne', [[tL, sonne.b], [tL, ch2], [aB, ch2], [aB, kr.cy], [a[0], a[1]]], a);
        a = inL(pb); add('sonne-powerbank', 'sonne', [[tL, sonne.b], [tL, pb.cy], [a[0], a[1]]], a);
        a = inR(kr); add('kurbel-kurbelradio', 'kurbel', [[tR, kurbel.b], [tR, kr.cy], [a[0], a[1]]], a);
        a = inR(kl); add('kurbel-kurbellampe', 'kurbel', [[tR, kurbel.b], [tR, ch1], [aA, ch1], [aA, kl.cy], [a[0], a[1]]], a);
        var pbB = pB(pb), krB = pB(kr);
        a = [xh1, handy.t - 1 - A, xh1, handy.t - 1];
        add('powerbank-handy', 'handy', [[pbB[0], pbB[1] + PR], [pbB[0], ch3], [xh1, ch3], [a[0], a[1]]], a, [['B', 'powerbank', pbB]]);
        a = [krB[0], handy.t - 1 - A, krB[0], handy.t - 1];
        add('kurbelradio-handy', 'handy', [[krB[0], krB[1] + PR], [a[0], a[1]]], a, [['B', 'kurbelradio', krB]]);
      } else {
        cb = box(caseEl, m);
        var row1t = Math.min(st('werkzeug').t, st('waerme').t, st('gesundheit').t);
        var yT = (cb.t + row1t + 8) / 2;   /* Mitte zwischen Rahmen und Versalhoehe der Woerter */
        var yB = Math.max(kl.b, kr.b) + G + A + R + 6;
        if (yB > cb.b - 10) return { ok: false, err: ['unterer Kanal zu eng'] };
        bS.style.top = f(yT - bS.offsetHeight / 2) + 'px';
        bK.style.top = f(yB - bK.offsetHeight / 2) + 'px'; bK.style.bottom = 'auto';
        bH.style.top = f((pb.cy + kr.cy) / 2 - bH.offsetHeight / 2) + 'px';
        sonne = box(bS, m); kurbel = box(bK, m); handy = box(bH, m);
        if (handy.t + 8 > pb.cy || kr.cy > handy.b - 8) return { ok: false, err: ['Handy deckt beide Ausgaenge nicht'] };
        var tLd = kl.l - G - A - R - 2;
        if (tLd < cb.l + 12) return { ok: false, err: ['linke Gasse zu schmal'] };
        var a1 = kr.l - G - A - R - 2, a2 = pb.l - G - A - R - 2;
        a = inL(kl); add('sonne-kurbellampe', 'sonne', [[sonne.r, yT], [tLd, yT], [tLd, kl.cy], [a[0], a[1]]], a);
        a = inL(kr); add('sonne-kurbelradio', 'sonne', [[sonne.r, yT], [a1, yT], [a1, kr.cy], [a[0], a[1]]], a);
        a = inL(pb); add('sonne-powerbank', 'sonne', [[sonne.r, yT], [a2, yT], [a2, pb.cy], [a[0], a[1]]], a);
        a = inB(kl); add('kurbel-kurbellampe', 'kurbel', [[kurbel.r, yB], [kl.cx, yB], [a[0], a[1]]], a);
        a = inB(kr); add('kurbel-kurbelradio', 'kurbel', [[kurbel.r, yB], [kr.cx, yB], [a[0], a[1]]], a);
        var pbR = pR(pb), krR = pR(kr);
        a = [handy.l - 1 - A, pb.cy, handy.l - 1, pb.cy];
        add('powerbank-handy', 'handy', [[pbR[0] + PR, pb.cy], [a[0], a[1]]], a, [['R', 'powerbank', pbR]]);
        a = [handy.l - 1 - A, kr.cy, handy.l - 1, kr.cy];
        add('kurbelradio-handy', 'handy', [[krR[0] + PR, kr.cy], [a[0], a[1]]], a, [['R', 'kurbelradio', krR]]);
      }
      /* Zuend-Linie Feuerzeug -> Kerzen, gepunktet */
      var xf = Math.max(fz.r, kz.r, word('licht').r - 6) + 4 + PR + 12;
      var t = inR(kz), fzP = pR(fz);
      add('feuerzeug-kerze', 'fire', [[fzP[0] + PR, fz.cy], [xf, fz.cy], [xf, kz.cy], [t[0], t[1]]], t, [['R', 'feuerzeug', fzP]], { fire: true });
      /* Owner 11.10.: keine Beschriftung "zuendet" an der Zuend-Linie (Screenreader-Text bleibt im Markup) */
      var lbl = null;
      err = check(m, list, lbl);
      return { ok: err.length === 0, err: err, list: list, lbl: lbl, D: D, A: A, AW: AW, PR: PR, R: R, cb: box(caseEl, m) };
    }

    /* Ausweich-Stufe ohne Leitungen. flow = Knoepfe als Zeile unter dem Koffer */
    function fallback() {
      var ws = arr(map.querySelectorAll('.bb-sk__w, .bb-sk__m')).map(function (n) { return n.classList.contains('bb-sk__m') ? n.offsetWidth - 6 : n.offsetWidth; });
      map.style.setProperty('--sk-colmin', Math.ceil(Math.max.apply(null, ws) + 2) + 'px');
      map.classList.add('is-plain');
      setHalf();
      var m = map.getBoundingClientRect(), W = map.clientWidth, s = box(bS, m), k = box(bK, m);
      var ok = s.r + 8 <= k.l;
      if (ok) {
        var hw = bH.offsetWidth, L = W - hw - 26;
        bH.style.left = f(L) + 'px'; bH.style.right = 'auto';
        ok = L > 0 && fitTags(m, L) && check(map.getBoundingClientRect(), [], null).length === 0;
      }
      if (ok) return 'plain';
      map.classList.remove('is-plain'); map.classList.add('is-flow'); tagN.classList.add('is-off');
      bH.style.left = ''; bH.style.right = '';
      map.style.setProperty('--sk-tagw', f(caseEl.clientWidth - 24) + 'px');
      map.style.setProperty('--sk-tagh', f(tagO.offsetHeight) + 'px');
      return 'flow';
    }

    function layout() {
      var D = desk.matches, res;
      reset();
      res = plan2(D);
      if (!res.ok && D) { reset(); root.classList.add('is-alt'); res = plan2(false); }
      var p;
      if (res.ok) p = D && !root.classList.contains('is-alt') ? 'd' : 'm';
      else { reset(); if (D) root.classList.add('is-alt'); p = fallback(); res = null; }
      root.setAttribute('data-sk-plan', p);
      var sig = p + JSON.stringify(res ? res.list.map(function (r) { return r.pts; }) : []);
      if (sig === lastSig && (res ? svg.firstChild : true)) return false;
      lastSig = sig;
      routes = res ? res.list : [];
      draw(res);
      return true;
    }

    function draw(res) {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      if (!res) { frameD = ''; applyState(false); return; }
      var gL = mk('g', { 'class': 'bb-sk__lines' }, svg);
      var gA = mk('g', { 'class': 'bb-sk__arrows' }, svg);
      var gP = mk('g', { 'class': 'bb-sk__ports' }, svg);
      var sub = function (layer, set) { return layer.querySelector('[data-set="' + set + '"]') || mk('g', { 'class': 'bb-sk__set', 'data-set': set }, layer); };
      routes.forEach(function (r) {
        r.d = rounded(r.pts, res.R);
        r.el = mk('path', { d: r.d, 'class': 'bb-sk__ln' + (r.fire ? ' bb-sk__ln--fire' : ''), 'data-set': r.set }, sub(gL, r.set));
        var tp = r.tip, dx = tp[2] - tp[0], dy = tp[3] - tp[1], L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L, AW = res.AW;
        var bx = tp[0] - ux * 0.6, by = tp[1] - uy * 0.6;
        r.arr = mk('path', { d: 'M' + f(tp[2]) + ',' + f(tp[3]) + ' L' + f(bx - uy * AW) + ',' + f(by + ux * AW) + ' L' + f(bx + uy * AW) + ',' + f(by - ux * AW) + ' Z', 'class': 'bb-sk__arr', 'data-set': r.set }, sub(gA, r.set));
        r.portEls = r.ports.map(function (p) { return mk('circle', { cx: f(p[2][0]), cy: f(p[2][1]), r: 2.6, 'class': 'bb-sk__port', 'data-set': r.set }, sub(gP, r.set)); });
      });
      applyState(false);
      /* Rahmenlinie (fuer die Rahmenrunde des Lichtlaufs) */
      var cb = res.cb, x0 = cb.l + 0.75, y0 = cb.t + 0.75, x1 = cb.r - 0.75, y1 = cb.b - 0.75, rr = 13.25, xm = (x0 + x1) / 2;
      frameD = 'M' + f(xm) + ',' + f(y0) + ' H' + f(x1 - rr) + ' A' + rr + ',' + rr + ' 0 0 1 ' + f(x1) + ',' + f(y0 + rr) + ' V' + f(y1 - rr) + ' A' + rr + ',' + rr + ' 0 0 1 ' + f(x1 - rr) + ',' + f(y1) +
        ' H' + f(x0 + rr) + ' A' + rr + ',' + rr + ' 0 0 1 ' + f(x0) + ',' + f(y1 - rr) + ' V' + f(y0 + rr) + ' A' + rr + ',' + rr + ' 0 0 1 ' + f(x0 + rr) + ',' + f(y0) + ' Z';
    }

    /* ---- Zustand ---- */
    function showCap(animate) {
      clearTimeout(capTimer);
      var next = caps[state];
      var settle = function () { Object.keys(caps).forEach(function (k) { var p = caps[k]; p.classList.toggle('is-on', p === caps[state]); p.classList.remove('is-out'); }); };
      var outgoing = Object.keys(caps).map(function (k) { return caps[k]; }).filter(function (p) { return p !== next && p.classList.contains('is-on'); });
      if (animate && outgoing.length && !next.classList.contains('is-on')) {
        outgoing.forEach(function (p) { p.classList.add('is-out'); });
        capTimer = setTimeout(settle, 120);
      } else settle();
    }
    function applyState(animate) {
      var set = SETS[state];
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-path') === state ? 'true' : 'false'); });
      routes.forEach(function (r) {
        var on = !set || set.r.indexOf(r.set) > -1;
        [r.el, r.arr].concat(r.portEls).forEach(function (n) { if (n) n.classList.toggle('is-dim', !on); });
      });
      arr(svg.querySelectorAll('.bb-sk__set')).forEach(function (g) { g.classList.toggle('is-dim', !!set && set.r.indexOf(g.getAttribute('data-set')) < 0); });
      arr(map.querySelectorAll('[data-m]')).forEach(function (n) { n.classList.toggle('is-on', !!set && set.m.indexOf(n.getAttribute('data-m')) > -1); });
      showCap(animate);
    }
    function select(k, animate) {
      var prev = state; state = k;
      applyState(animate && !reduce());
      if (live && k !== prev) live.textContent = caps[k].textContent;
      if (animate && !reduce() && k !== 's0') runSet(SETS[k].r);
    }

    /* ---- Lichtlauf (nur Zugabe, Grundzustand = Endzustand) ---- */
    function stopRun() { running.forEach(function (a) { try { a.cancel(); } catch (e) { /* bereits beendet */ } }); running = []; var o = svg.querySelector('.bb-sk__ov'); if (o) o.parentNode.removeChild(o); }
    function overlay() { stopRun(); var g = mk('g', { 'class': 'bb-sk__ov' }); svg.insertBefore(g, svg.querySelector('.bb-sk__arrows')); return g; }
    function grow(g, d, delay, dur) {
      var h = mk('path', { d: d, 'class': 'bb-sk__halo', pathLength: 100, 'stroke-dasharray': '100 102', 'stroke-dashoffset': 100 }, g);
      var l = mk('path', { d: d, 'class': 'bb-sk__run', pathLength: 100, 'stroke-dasharray': '100 102', 'stroke-dashoffset': 100 }, g);
      var o = { delay: delay, duration: dur, easing: 'ease-in-out', fill: 'both' };
      running.push(h.animate([{ strokeDashoffset: 100 }, { strokeDashoffset: 0 }], o), l.animate([{ strokeDashoffset: 100 }, { strokeDashoffset: 0 }], o));
    }
    /* Stationswort faerbt sich kurz in --bb-blue-ink, wenn seine Leitung ankommt */
    function glow(stKey, delay) {
      var w = map.querySelector('[data-st="' + stKey + '"] .bb-sk__w'); if (!w) return;
      var a = tok('--bb-ink'), b = tok('--bb-blue-ink');
      running.push(w.animate([{ color: a }, { color: b, offset: 0.3 }, { color: b, offset: 0.6 }, { color: a }], { delay: delay, duration: 900, easing: 'ease-out', fill: 'both' }));
    }
    function fadeGroup(g, at, total) {
      running.push(g.animate([{ opacity: 1 }, { opacity: 1, offset: at / total }, { opacity: 0 }], { duration: total, fill: 'both' }));
    }
    function cleanupWhenDone() {
      var mine = running.slice();
      Promise.all(mine.map(finished)).then(function () { if (running.length && running[0] === mine[0]) stopRun(); }, function () {});
    }
    function runAll() {
      if (!routes.length || !canAnim) return;
      var g = overlay();
      var T = { sonne: [0, 700], kurbel: [300, 700], handy: [800, 600] };
      routes.forEach(function (r) { if (!r.fire) grow(g, r.d, T[r.set][0], T[r.set][1]); });
      var fire = routes.filter(function (r) { return r.fire; })[0];
      if (fire) {
        var fl = mk('path', { d: fire.d, 'class': 'bb-sk__run bb-sk__run--fire', opacity: 0 }, g);
        running.push(fl.animate([{ opacity: 0 }, { opacity: 1, offset: 0.5 }, { opacity: 0.55 }], { delay: 1100, duration: 300, easing: 'ease-in-out', fill: 'both' }));
      }
      grow(g, frameD, 1400, 1000);
      fadeGroup(g, 2400, 2700);
      ['licht', 'energie', 'information'].forEach(function (k) { glow(k, 560); });
      glow('werkzeug', 1100);
      glowFrame(1400, 1000);
      cleanupWhenDone();
    }
    /* Waerme und Gesundheit haben keine Leitung: sie leuchten, wenn die Rahmenrunde vorbeikommt */
    function glowFrame(start, dur) {
      var mb = map.getBoundingClientRect(), cbx = box(caseEl, mb), w = cbx.r - cbx.l, h = cbx.b - cbx.t, Pm = 2 * (w + h);
      ['waerme', 'gesundheit'].forEach(function (k) {
        var d = box(map.querySelector('[data-st="' + k + '"] .bb-sk__w'), mb);
        var dTop = d.cy - cbx.t, dBot = cbx.b - d.cy, dR = cbx.r - d.cx, mn = Math.min(dTop, dBot, d.cx - cbx.l, dR), s;
        if (mn === dTop) s = (d.cx - (cbx.l + w / 2) + Pm) % Pm;
        else if (mn === dR) s = w / 2 + (d.cy - cbx.t);
        else if (mn === dBot) s = w / 2 + h + (cbx.r - d.cx);
        else s = w * 1.5 + h + (cbx.b - d.cy);
        glow(k, start + dur * (s / Pm) - 200);
      });
    }
    function runSet(sets) {
      if (!routes.length || !canAnim) return;
      var g = overlay();
      routes.forEach(function (r) { if (sets.indexOf(r.set) > -1) grow(g, r.d, 0, 600); });
      fadeGroup(g, 600, 900);
      cleanupWhenDone();
    }

    /* ---- Bedienung ---- */
    function onClick(e) { var k = e.currentTarget.getAttribute('data-path'); select(state === k ? 's0' : k, true); }
    function onKey(e) { if ((e.key === 'Escape' || e.key === 'Esc') && state !== 's0') select('s0', true); }
    /* Ohne Skript tragen die Knoepfe aria-disabled (sie schalten dann nichts), ab hier sind sie bedienbar */
    btns.forEach(function (b) { b.addEventListener('click', onClick); b.removeAttribute('aria-disabled'); });
    root.addEventListener('keydown', onKey);

    /* ---- Start ---- */
    function schedule() {
      if (pending || dead) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false; if (dead) return;
        var cur = svg.querySelector('.bb-sk__ov');
        if (cur) cur.parentNode.removeChild(cur);
        var changed = layout();
        if (cur && !changed && routes.length) { svg.insertBefore(cur, svg.querySelector('.bb-sk__arrows')); return; }
        if (changed) stopRun();
      });
    }
    function onDesk() { schedule(); }
    function start() {
      if (dead) return;
      /* is-ready zuerst: die Ohne-JS-Regeln unter 360 px (eb-bb-tasks.css) duerfen die erste Messung nicht verfaelschen */
      map.classList.add('is-ready');
      layout();
      if (!reduce() && canAnim && typeof window.IntersectionObserver === 'function') {
        /* Lauf erst, wenn die ganze Karte ueber der Kaufleiste steht, bei sehr hoher Karte 85 % der Flaeche.
           Leistenhoehe inkl. Home-Leiste kommt aus dem CSS (scroll-margin-bottom der Karte) */
        /* Live-Hoehe der Kaufleiste hat Vorrang, wenn sie hoeher ist (701–989 px bricht ihre Vertrauenszeile zweizeilig um, 69,8 statt 64 px [GEMESSEN 10.10.]) */
        var sb = document.querySelector('.bb-sticky-bar');
        var bar = Math.max(0, Math.round(Math.max(parseFloat(getComputedStyle(map).scrollMarginBottom) || 0, sb ? sb.offsetHeight : 0))), th = [];
        for (var i = 0; i <= 20; i++) th.push(i / 20);
        th.push(0.98, 0.99);
        io = new IntersectionObserver(function (es) {
          var e = es[0]; if (!e.isIntersecting || ran || dead) return;
          var rh = e.rootBounds ? e.rootBounds.height : window.innerHeight - bar;
          if (e.intersectionRect.height + 0.5 < Math.min(e.boundingClientRect.height - 4, rh * 0.85)) return;
          ran = true; io.disconnect(); io = null;
          if (!reduce()) runAll();
        }, { threshold: th, rootMargin: '0px 0px -' + bar + 'px 0px' });
        io.observe(map);
      }
      if (typeof window.ResizeObserver === 'function') {
        ro = new ResizeObserver(schedule);
        ro.observe(map);
        arr(map.querySelectorAll('[data-st], .bb-sk__term, .bb-sk__tag')).forEach(function (n) { ro.observe(n); });
      } else window.addEventListener('resize', schedule);
      if (desk.addEventListener) desk.addEventListener('change', onDesk);
      else if (desk.addListener) desk.addListener(onDesk);
    }

    root.__ebBbSk = {
      destroy: function () {
        dead = true;
        clearTimeout(capTimer);
        stopRun();
        if (io) io.disconnect();
        if (ro) ro.disconnect(); else window.removeEventListener('resize', schedule);
        if (desk.removeEventListener) desk.removeEventListener('change', onDesk);
        else if (desk.removeListener) desk.removeListener(onDesk);
        btns.forEach(function (b) { b.removeEventListener('click', onClick); b.setAttribute('aria-disabled', 'true'); });
        root.removeEventListener('keydown', onKey);
        delete root.__ebBbSk;
      }
    };
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(start, start);
  }

  function initAll(scope) { arr((scope || document).querySelectorAll('[data-bb-sk]')).forEach(init); }
  function destroyAll(scope) { arr((scope || document).querySelectorAll('[data-bb-sk]')).forEach(function (r) { if (r.__ebBbSk) r.__ebBbSk.destroy(); }); }
  window.ebBbTasks = { initAll: initAll, destroyAll: destroyAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
})();
